import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateBooking } from 'repositories/BerthApi/updateBooking'
import { berthKeys, bookingKeys } from 'repositories/queryKeys'

export function useUpdateBooking() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateBooking,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: berthKeys.managements() })
      queryClient.invalidateQueries({ queryKey: bookingKeys.unassigned() })
      queryClient.invalidateQueries({ queryKey: bookingKeys.details() })
    },
  })
}
